import React from 'react';
import { Row, Col, Button, Form } from 'antd';

import { DateInput } from 'components/atom/form';
import { GetCurrentFYDates } from 'utils/date';
import { useCurrentOrganization } from 'hooks';

interface DateRangeInputProps {
  disabled: boolean;
}

export function DateRangeInput(props: DateRangeInputProps) {
  const form = Form.useFormInstance();
  const currentOrganization = useCurrentOrganization();

  const onLastFy = () => {
    const { fyStart, fyEnd } = GetCurrentFYDates(currentOrganization);
    form.setFieldsValue({
      startDate: fyStart.add({ year: -1 }),
      endDate: fyEnd.add({ year: -1 }),
    });
  };
  const onCurrentFy = () => {
    const { fyStart, fyEnd } = GetCurrentFYDates(currentOrganization);
    form.setFieldsValue({
      startDate: fyStart,
      endDate: fyEnd,
    });
  };
  const onLastMonth = () => {
    const { now } = GetCurrentFYDates(currentOrganization);
    form.setFieldsValue({
      startDate: now.clone().add({ month: -1 }).startOf('month'),
      endDate: now.clone().add({ month: -1 }).endOf('month'),
    });
  };
  const onCurrentMonth = () => {
    const { now } = GetCurrentFYDates(currentOrganization);
    form.setFieldsValue({
      startDate: now.clone().startOf('month'),
      endDate: now.clone().endOf('month'),
    });
  };

  const buttonProps = { type: 'dashed' as const, style: { width: '100%', marginBottom: '10px' } };

  return (
    <>
      <Row gutter={10}>
        <Col flex="1">
          <DateInput name="startDate" label="Start date" required disabled={props.disabled} />
        </Col>
        <Col flex="1">
          <DateInput name="endDate" label="End date" required disabled={props.disabled} />
        </Col>
      </Row>
      <Row gutter={10} className="no-print">
        <Col xs={12} sm={6}>
          <Button {...buttonProps} onClick={onLastFy}>
            Last FY
          </Button>
        </Col>
        <Col xs={12} sm={6}>
          <Button {...buttonProps} onClick={onCurrentFy}>
            This FY
          </Button>
        </Col>
        <Col xs={12} sm={6}>
          <Button {...buttonProps} onClick={onLastMonth}>
            Last Month
          </Button>
        </Col>
        <Col xs={12} sm={6}>
          <Button {...buttonProps} onClick={onCurrentMonth}>
            This Month
          </Button>
        </Col>
      </Row>
    </>
  );
}
